import React from 'react'
import logo from '../../../assets/logo.png'

const Header = ({ noText }) => {
    return (
        <div className='margin-bottom-large'>
            <div className='logo-container-top'>
                <img src={logo} alt="logo" className='logo-large' />&emsp;
                <span className='logo-title-large'>VisualSense</span>
            </div>
            {noText ? '' : <p className='logo-container-top'>Lyon, France</p>}

        </div>
    )
}

export default Header
